import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

export const refreshApp = (editorSDK: FlowEditorSDK, source: string) => {
  return editorSDK.document.application.livePreview.refresh('', {
    source,
    shouldFetchData: true,
  });
};
